var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.667 24c0-.736.597-1.333 1.333-1.333h8a1.333 1.333 0 0 1 0 2.666h-8A1.333 1.333 0 0 1 10.667 24ZM6.667 16c0-.736.597-1.333 1.333-1.333h16a1.333 1.333 0 0 1 0 2.666H8A1.333 1.333 0 0 1 6.667 16ZM2.667 8c0-.736.597-1.333 1.333-1.333h24a1.333 1.333 0 1 1 0 2.666H4A1.333 1.333 0 0 1 2.667 8Z",
  clipRule: "evenodd"
})));
SvgFilter.viewBox = '0 0 32 32';
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export default ForwardRef;